<section class="form-section basket">
  <div class="header">
    <h2>
      <strong>{{ title }}</strong>
    </h2>
  </div>

  <div class="cart-summary">
    <div class="cart-items">
      @for (item of cartItems; track item) {
        <div class="cart-item">
          <div class="name-price">
            <h4>{{ item.name }}</h4>
            <p>£{{ item.price.toFixed(2) }} x {{ item.quantity }}</p>
          </div>
          @if (item.extras?.length) {
            <ul class="extras-list">
              @for (extra of item.extras; track extra) {
                <li>
                  + {{ extra.choice }}
                  @if (extra.price > 0) {
                    <span>
                      ({{ extra.price | currency: "GBP" }})
                    </span>
                  }
                </li>
              }
            </ul>
          }
        </div>
      }
    </div>

    <div class="cart-notes">
      <div class="notes-header">
        <span class="notes-title"><strong>Notes for restaurant</strong></span>

        @if (editableNotes && !isEditingNotes) {
          <button
            type="button"
            class="linkish"
            (click)="startEditNotes.emit()"
            >
            {{ orderNotes ? "Edit" : "Add" }}
          </button>
        }
      </div>

      @if (orderNotes && !isEditingNotes) {
        <p class="notes-text">
          {{ orderNotes }}
        </p>
      }

      @if (!orderNotes && !isEditingNotes) {
        <p class="notes-empty">
          No notes added.
        </p>
      }

      @if (editableNotes && isEditingNotes) {
        <div class="notes-editor">
          <textarea
            [ngModel]="orderNotesDraft"
            (ngModelChange)="orderNotesDraftChange.emit($event)"
            maxlength="500"
            placeholder="Add any special instructions…"
            rows="4"
            style="width: 100%"
          ></textarea>
          <div class="notes-editor__actions">
            <small>{{ orderNotesDraft.length || 0 }}/500</small>
            <div class="notes-editor__buttons">
              <button
                type="button"
                class="btn-secondary"
                (click)="cancelEditNotes.emit()"
                >
                Cancel
              </button>
              <button
                type="button"
                class="btn-primary"
                (click)="saveNotes.emit()"
                >
                Save
              </button>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="cart-fees">
      @if (serviceFee > 0) {
        <div class="fee-line">
          <span>Service Fee</span>
          <span>{{ serviceFee | currency: "GBP" }}</span>
        </div>
      }

      @if (isDelivery && deliveryFee > 0) {
        <div class="fee-line">
          <span>Delivery Fee</span>
          <span>{{ deliveryFee | currency: "GBP" }}</span>
        </div>
      }

      @if (smallOrderFee > 0) {
        <div class="fee-line">
          <span>Small-order Fee</span>
          <span>{{ smallOrderFee | currency: "GBP" }}</span>
        </div>
      }
    </div>

    <p class="cart-total">
      <strong>Total:</strong>
      {{ total | currency: "GBP" }}
    </p>
  </div>
</section>
